const rootKey = '/sow-change-reqs';

export const fetchSowChangeReqs = () => {
  return `${rootKey}/fetch`;
};

export const executeSowChangeReq = () => {
  return `${rootKey}/execute`;
};

export const rejectSowChangeReq = () => {
  return `${rootKey}/reject`;
};

export const recentSowChanges = () => `${rootKey}/fetch-recent-changes`;
